import script from "./ButtonIconAccentSecondary.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonIconAccentSecondary.vue?vue&type=script&setup=true&lang=js"

import "./ButtonIconAccentSecondary.vue?vue&type=style&index=0&id=07cf17a1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-07cf17a1"]])

export default __exports__